import React, { Component } from "react";
import PropTypes from "prop-types";
import { DialogBox, DialogBoxFooterType, NoLink, SelectInput, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { model } from "./../data";
import {
    getAgBytesErrorClassNames,
    mapNameToPicklistValue,
    prepareSelectableOptions,
} from "~/admin/utils";
import { adminData, ID, PICKLIST_GUID, VALUE } from "~/admin/data";
import { messages } from "./../../i18n-messages";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";

const PROPS_GENE_TRAIT_CHARACTERISTIC_NAME = "traitCharacteristicName";

class TraitCharacteristicList extends Component {
    static propTypes = {
        apiErrors: PropTypes.array,
        deleteItem: PropTypes.func,
        editData: PropTypes.object,
        formatMessage: PropTypes.func,
        isDeleting: PropTypes.bool,
        isEditing: PropTypes.bool,
        onAdd: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onEdit: PropTypes.func,
        options: PropTypes.array,
        record: PropTypes.array,
        renderDeleteModal: PropTypes.func,
        toggleModal: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            geneTraitCharacteristicGuid: null,
            editOptions: [],
            editingItem: false,
        };
    }

    initializeDropdowns = (options) => {
        this.setState({
            editOptions: prepareSelectableOptions(options, {
                guid: PICKLIST_GUID,
                label: VALUE,
                id: ID,
                appendIdToLabel: true,
            }),
        });
    };

    onEdit = (record, index) => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [PROPS_GENE_TRAIT_CHARACTERISTIC_NAME],
                key: VALUE,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, toggleModal } = this.props;
        return (
            <DialogBox
                action="save"
                actionDisabled={!editData[model.PROPS_TRAIT_CHARACTERISTIC_NAME]}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                forceOverflow
                isOpen={isEditing}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.traitCharacteristic
                )}
                testId="trait-characteristics-add-edit-modal"
            >
                <SelectInput
                    required
                    tabIndex={0}
                    autoFocus
                    optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                    openOnFocus={false}
                    options={this.state.editOptions}
                    placeholderText={formatMessage(messages.traitCharacteristicName)}
                    value={mapNameToPicklistValue({
                        options: this.state.editOptions,
                        selectedName: editData[model.PROPS_TRAIT_CHARACTERISTIC_NAME],
                    })}
                    onChange={(value) => {
                        this.props.onChange({
                            [model.PROPS_TRAIT_CHARACTERISTIC_NAME]: value ? value.name : "",
                        });
                    }}
                    testId="trait-characteristics-name-select"
                />
            </DialogBox>
        );
    };

    render() {
        const { record, formatMessage, renderDeleteModal } = this.props;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {record && record.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={record}
                        columns={{
                            [PROPS_GENE_TRAIT_CHARACTERISTIC_NAME]: {
                                title: formatMessage(messages.name),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        classNames={getAgBytesErrorClassNames(258, this.props.apiErrors, [
                            "add-link",
                        ])}
                        label={createAddLinkLabelText(formatMessage, messages.traitCharacteristic)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(TraitCharacteristicList);
